import { useForm } from "react-hook-form";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect, useState } from "react";
import { Button } from "antd";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CountryCodeInput from "../../Components/CommonCommponents/CountyCodeInput";

const ContactDetails = (props) => {
  const [isCountryLayout, setCountryLayout] = useState(false);
  const [phoneCode, setPhonecode] = useState();
  console.log("propz", props.details.candidate_details_id);
  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    reset,
    formState: { errors, dirtyFields },
    watch,
  } = useForm({
    // defaultValues : data
  });
  console.log("testerrors", errors);
  const handelInputChange = (onChange, e) => {
    onChange(e);
    if (e.target.value !== "") {
      var test = Number(e.target.value);
      var test1 = Number.isInteger(test);
      if (test1) {
        setCountryLayout(true);
        setPhonecode("+91");
      } else {
        setCountryLayout(false);
        setPhonecode("");
      }
    } else {
      setCountryLayout(false);
      setPhonecode("");
    }
  };

  const handelChangePhone = (e) => {
    var value = `+${e}`;
    setPhonecode(value);
  };
  const getDetails = (data) => {
    setValue("first_name", props.details?.first_name);
    setValue("last_name", props.details?.last_name);
    setValue("country_code", props.details?.country_code);
    setValue(
      "mobile_number",
      props.details?.national_number != false
        ? props.details?.national_number
        : ""
    );
  };
  useEffect(() => {
    getDetails();
  }, [props.details]);

  const onSubmit = async (data) => {
    console.log("dirtyFields", dirtyFields);
    let modifiedData = {};

    // const json = {
    //   email: data.email,
    //   first_name: data.first_name,
    //   last_name: data.last_name,
    //   mobile_number: data.mobile_number
    //     ? data.country_code
    //       ? `+${data.country_code}${data.mobile_number}`
    //       : `+91${data.mobile_number}`
    //     : "",
    // };

    if (dirtyFields["mobile_number"] && data["mobile_number"] !== "") {
      data["mobile_number"] = data.mobile_number
        ? data.country_code
          ? `+${data.country_code}${data.mobile_number}`
          : `+91${data.mobile_number}`
        : "";
    }
    Object.keys(data).forEach((key) => {
      // Check if the field is modified and it's not empty
      if (dirtyFields[key] && data[key] !== "") {
        modifiedData[key] = data[key];
      }
    });

    await CandodateService.updateContactDetails(
      modifiedData,
      props?.details?.id
    )
      .then(
        (response) => {
          if (response.data.success == true) {
            toast.success("Sucessfully Registered");
            props.close();
          }
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((error) => {
        toast.error("Failed To Register");
      });
  };
  return (
    <div className="w-full pb-6 p-4 flex">
      <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
        <div class="px-2">
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="md:w-1/2 sm:w-full px-4">
              <Input
                name="first_name"
                label="First Name"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
            <div class="md:w-1/2 sm:w-full px-4">
              <Input
                name="last_name"
                label="Last Name"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>
          {/* <div class="flex -mx-2 md:flex-row flex-col">
            <div className="w-full ">
              <div style={{ display: "flex" }}>
                {isCountryLayout && (
                  <span
                    style={{
                      width: "10%",
                      paddingLeft: "5px",
                      paddingTop: "5px",
                      marginTop: "34px",
                      paddingRight: "45px",
                    }}
                  >
                    <PhoneInput
                      country="In"
                      value="91"
                      inputStyle={{
                        height: "35px",
                        width: "2%",
                        paddingLeft: "0px",
                      }}
                      onChange={(e) => handelChangePhone(e)}
                    />
                  </span>
                )}
                <div className="w-full ">
                  <Input
                    name="mobile_number"
                    label="Mobile number"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    onChange={handelInputChange}
                  />
                </div>
              </div>
            </div>
          </div> */}
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <CountryCodeInput
                name="mobile_number"
                country_code_name="country_code"
                country_code_value={watch("country_code")}
                value={watch("mobile_number")}
                setValue={setValue}
                label="Mobile number"
                required={true}
                control={control}
                rules={{
                  required: "This field is required",
                }}
              />
              {/* <Input
                      name="mobile_number"
                      label="Mobile number"
                      placeholder="Enter your Mobile number"
                      control={control}
                      rules={{
                        required: "This field is required",
                      }}
                      className="h-12"
                    /> */}
            </div>
          </div>

          <div className="mb-6 mt-2">
            <label className=" text-base font-normal px-2">Email Address</label>
            <p className="mt-2 text-gray-600 font-poppins text-base font-normal px-2">
              {props.details?.email}
            </p>
          </div>

          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="email"
                label="Change Email"
                placeholder="Enter Email"
                control={control}
                className="h-12 "
              />
              <p className="font-Poppins text-red-500 text-xs font-normal">
                We will send you a verification email on this email ID
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end mt-6 px-4">
          <Button
            htmlType="submit"
            type="submit"
            className="bg-[#000000] text-white text-base rounded-3xl"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};
export default ContactDetails;
